import React, {  Component } from 'react';

export default class PayByCreditCardOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("PayByCreditCardOverlayDialog", false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectionsNotConfirmed">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Pay By Credit Card</h2>
                    <p>Credit card payment is temporarily unavailable. If you need to pay by credit card, please ENTER your order and call 1-800-242-1333 so the CustomerNet Help Desk can complete your order.</p>
					<a className="blueButton yesButton" onClick={this.closeDialog.bind(this)}>Ok</a>
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/payByCreditCardOverlayDialog.js